const OBJECT_URL_REVOCATION_DELAY_MS = 1_000;

/** Déclenche l'enregistrement d'un Blob sous `filename` (ancre temporaire + URL d'objet). */
export function saveBlobAsFile(blob: Blob, filename: string) {
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.rel = 'noopener noreferrer';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Révoquer tout de suite peut interrompre le téléchargement sur certains navigateurs.
  setTimeout(() => URL.revokeObjectURL(objectUrl), OBJECT_URL_REVOCATION_DELAY_MS);
}

/**
 * Télécharge un fichier distant puis l'enregistre. Les URL présignées de stockage
 * s'appellent sans cookie (`omit`) ; seules les routes de l'API demandent `withCredentials`.
 */
export async function downloadRemoteFile(
  url: string,
  filename: string,
  options: { withCredentials?: boolean } = {},
) {
  const response = await fetch(url, { credentials: options.withCredentials ? 'include' : 'omit' });
  if (!response.ok) {
    throw new Error('download_failed');
  }
  saveBlobAsFile(await response.blob(), filename);
}
